<template>
  <div>
    <v-row>
      <v-col :cols="isMobile ? 12 : 4">
        <v-text-field v-model="amount" label="Amount"></v-text-field>
      </v-col>
      <v-col :cols="isMobile ? 12 : 4">
        <v-text-field v-model="reason" label="Reason"></v-text-field>
      </v-col>
      <v-col :cols="isMobile ? 12 : 4">
        <vAutoComplete
          v-if="isManager"
          :items="statuses"
          @item-selected="setDiscountStatus"
          label="Select Status"
        ></vAutoComplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="isMobile ? 12 : 4">
        <vButton
          label="Create Discount"
          :color="getThemeColor"
          icon="mdi-plus"
          @button-clicked="createDiscount"
        ></vButton>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import studentsJs from "@/plugins/students";
import vAutoComplete from "@/components/Legos/vAutoComplete.vue";
import vInputField from "@/components/Legos/vInputField.vue";
import vButton from "@/components/Legos/vButton.vue";
export default {
  components: {
    vInputField,
    vButton,
    vAutoComplete,
  },
  props: {
    selectedStudentSid: {
      default: null,
    },
  },
  watch: {
    selectedStudentSid(newVal) {
      this.sid = newVal;
    },
  },
  mounted() {
    this.sid = this.selectedStudentSid;
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
  },
  data: () => ({
    sid: null,
    amount: 0,
    reason: null,
    statuses: ["Pending", "Approved", "Not Approved"],
    status: "Pending",
  }),
  methods: {
    setDiscountStatus(status) {
      this.status = status;
    },
    async createDiscount() {
      if (this.sid != null) {
        this.$store.commit("setLoader", true);
        const discounts = await studentsJs.createStudentDiscount(
          this.sid,
          this.amount,
          this.reason,
          this.status
        );
        this.$store.commit("setLoader", false);
        this.$toast.success("Dsicount Created Successfully!", {
          duration: 3000,
        });
        this.$emit("discount-created", discounts);
      } else {
        alert("Student Must Be Selected!");
      }
    },
  },
};
</script>
